export default {
  label_system_link: "System Link",
  x_selected: "{count} selected",
  warning_invalid_filter_params:
    "The filter parameters in the url is invalid. Please update the url or use the Filter dialog instead.",
}
